export default (query, match) => {
  const params = new URLSearchParams(query);

  return params.has(match) ? params.get(match) : null;
};
